import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SITE } from '../data/content';
import Logo from './Logo';
import './Footer.css';

export default function Footer() {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();

  const links = [
    { href: '#home', label: t.nav.home },
    { href: '#about', label: t.nav.about },
    { href: '#materials', label: t.nav.materials },
    { href: '#markets', label: t.nav.markets },
    { href: '#contact', label: t.nav.contact },
  ];

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <a href="#home" className="site-footer__logo">
            <Logo size={36} mono />
            <span>{lang === 'ar' ? 'علم ليبيا' : 'Libyan Flag'}</span>
          </a>
          <p>{t.footer.tagline}</p>
        </div>

        <div className="site-footer__col">
          <h4>{t.footer.quickLinks}</h4>
          <ul>
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>{t.contact.title}</h4>
          <ul>
            <li>
              <a href={`mailto:${SITE.email}`} dir="ltr">{SITE.email}</a>
            </li>
            <li>
              <a href={`tel:${SITE.phoneHref}`} dir="ltr">{SITE.phone}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container site-footer__bottom-inner">
          <span>
            © {year} {lang === 'ar' ? 'شركة علم ليبيا لاستيراد المواد الخام' : 'Libyan Flag Company'} — {t.footer.rights}
          </span>
        </div>
      </div>
    </footer>
  );
}
